import { render, staticRenderFns } from "./attribute-dictionary-manager.vue?vue&type=template&id=54ed6629"
import script from "./attribute-dictionary-manager.vue?vue&type=script&lang=js"
export * from "./attribute-dictionary-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports